export default '/build/f1aba3f1.svg'